/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { ERequestStatus } from './types';

export const isPending = (status: ERequestStatus): boolean => status === ERequestStatus.PENDING;

export const isSuccess = (status: ERequestStatus): boolean => status === ERequestStatus.FULFILLED;

export const isError = (status: ERequestStatus): boolean => status === ERequestStatus.REJECTED;

export const isCancelled = (status: ERequestStatus): boolean => status === ERequestStatus.CANCELLED;

export const isIdle = (status: ERequestStatus): boolean => status === ERequestStatus.IDLE;

export const isComplete = (status: ERequestStatus): boolean =>
  status !== ERequestStatus.PENDING && status !== ERequestStatus.IDLE;

export const canRetry = (status: ERequestStatus): boolean =>
  status === ERequestStatus.REJECTED ||
  status === ERequestStatus.CANCELLED ||
  status === ERequestStatus.IDLE;

export const isLoading = (status: ERequestStatus): boolean => isPending(status);

export const isFinished = (status: ERequestStatus): boolean => isSuccess(status) || isError(status);
